import role5Schema from '../../../../assets/forms/role-120100.form.json';
import { SHEET_KEYS } from '../../../models/sheet-keys';
import { getRole5VisibleDirectorCount } from '../validators/role5-statement-by-directors.rules';
import { makeDirectorCountProjector } from './make-director-count-projector';

/**
 * Strips role 5's hidden director fields at submit (director quads 2–5, visible
 * only when `ui.directorNumber <= NumberOfDirectorsSigningStatementByDirectors`,
 * default 2). The three "other person" fields carry no `ui.directorNumber` and
 * are therefore never stripped — they are always visible (their required-state
 * is governed separately by `requiredIfAllVisibleDirectorsMatch`, which does not
 * affect visibility). Reuses `getRole5VisibleDirectorCount` for parity with the
 * component and the pure validator.
 */
export const role5StatementByDirectorsProjector = makeDirectorCountProjector(
  SHEET_KEYS.statementByDirectors,
  getRole5VisibleDirectorCount,
  role5Schema.controls as Array<{ qname: string; ui?: { directorNumber?: number } }>
);
